import React, { Suspense, lazy } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Layout } from './components/Layout';

import { ScrollToTop } from './components/ScrollToTop';
import { CartProvider } from './context/CartContext';
import { AuthProvider } from './context/AuthContext';
import { CartDrawer } from './components/CartDrawer';

// Lazy load pages to reduce initial bundle size
const Home = lazy(() => import('./pages/Home').then(m => ({ default: m.Home })));
const Shop = lazy(() => import('./pages/Shop').then(m => ({ default: m.Shop })));
const Subscriptions = lazy(() => import('./pages/Subscriptions').then(m => ({ default: m.Subscriptions })));
const ProductDetails = lazy(() => import('./pages/ProductDetails').then(m => ({ default: m.ProductDetails })));
const Story = lazy(() => import('./pages/Story').then(m => ({ default: m.Story })));
const FAQ = lazy(() => import('./pages/FAQ').then(m => ({ default: m.FAQ })));
const Contact = lazy(() => import('./pages/Contact').then(m => ({ default: m.Contact })));
const Shipping = lazy(() => import('./pages/Shipping').then(m => ({ default: m.Shipping })));
const PrivacyPolicy = lazy(() => import('./pages/PrivacyPolicy').then(m => ({ default: m.PrivacyPolicy })));
const Consent = lazy(() => import('./pages/Consent').then(m => ({ default: m.Consent })));
const ResetPassword = lazy(() => import('./pages/ResetPassword').then(m => ({ default: m.ResetPassword })));
const Profile = lazy(() => import('./pages/Profile').then(m => ({ default: m.Profile })));
const Success = lazy(() => import('./pages/Success').then(m => ({ default: m.Success })));
const Blog = lazy(() => import('./pages/Blog').then(m => ({ default: m.Blog })));
const Article = lazy(() => import('./pages/Article').then(m => ({ default: m.Article })));
const Ingredients = lazy(() => import('./pages/Ingredients').then(m => ({ default: m.Ingredients })));
const TreatRunner = lazy(() => import('./pages/TreatRunnerPage').then(m => ({ default: m.TreatRunnerPage })));

// Loading fallback
const PageLoader = () => (
  <div className="min-h-screen flex items-center justify-center bg-background">
    <div className="w-12 h-12 border-4 border-primary/20 border-t-primary rounded-full animate-spin"></div>
  </div>
);

export default function App() {
  return (
    <AuthProvider>
      <CartProvider>
        <BrowserRouter>
        <ScrollToTop />
        <CartDrawer />
        <Suspense fallback={<PageLoader />}>
          <Routes>
            <Route path="/" element={<Layout />}>
              <Route index element={<Home />} />
              <Route path="shop" element={<Shop />} />
              <Route path="subscribe" element={<Subscriptions />} />
              <Route path="shop/:id" element={<ProductDetails />} />
              <Route path="story" element={<Story />} />
              <Route path="blog" element={<Blog />} />
              <Route path="blog/:slug" element={<Article />} />
              <Route path="faq" element={<FAQ />} />
              <Route path="ingredients" element={<Ingredients />} />
              <Route path="contact" element={<Contact />} />
              <Route path="shipping" element={<Shipping />} />
              <Route path="privacy-policy" element={<PrivacyPolicy />} />
              <Route path="oauth/consent" element={<Consent />} />
              <Route path="reset-password" element={<ResetPassword />} />
              <Route path="profile" element={<Profile />} />
              <Route path="success" element={<Success />} />
              <Route path="treat-runner" element={<TreatRunner />} />
            </Route>
          </Routes>
        </Suspense>
      </BrowserRouter>
    </CartProvider>
  </AuthProvider>
  );
}
